import { Helmet } from 'react-helmet-async';

export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-yellow-100">
      <Helmet>
        <title>Privacy Policy | PropViper</title>
        <meta name="description" content="Learn how PropViper collects, uses, and protects your personal information in accordance with our Privacy Policy." />
      </Helmet>

      <section className="bg-gradient-to-br from-black to-gray-900 py-16 sm:py-20 text-center px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 text-yellow-400">Privacy Policy</h1>
          <p className="text-base sm:text-lg text-yellow-200">Effective date: April 9, 2025</p>
        </div>
      </section>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-16 space-y-10 text-yellow-100 text-base leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">1. Information We Collect</h2>
          <p>
            We collect personal information that you voluntarily provide to us, such as your name and email address when you subscribe to our newsletter or contact us.
            We may also collect anonymous usage data through analytics tools to improve our services.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">2. How We Use Your Information</h2>
          <p>
            We use your personal data to send newsletters, respond to inquiries, and improve your experience on PropViper. We never sell your information to third parties.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">3. Cookies & Tracking</h2>
          <p>
            We use cookies and similar technologies to track user behavior, improve performance, and personalize content. You may choose to disable cookies through your browser settings.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">4. Third-Party Services</h2>
          <p>
            We may use third-party platforms like Google Analytics or affiliate providers. These services may collect information in accordance with their own privacy policies.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">5. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your data, but no method of transmission or storage is 100% secure.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">6. Your Rights</h2>
          <p>
            You may request to access, correct, or delete your personal data at any time by contacting us at <a href="mailto:support@propviper.com" className="text-yellow-400 underline">support@propviper.com</a>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">7. Changes to This Policy</h2>
          <p>
            We reserve the right to update this Privacy Policy. Any changes will be posted on this page with an updated effective date.
          </p>
        </section>
      </main>
    </div>
  );
}
